import { useCallback } from 'react';

export interface MobileNavigationHandlers {
    handleSearchClick: () => void;
    handleMenuClick: () => void;
    handleSortClick: () => void;
    handleFilterClick: () => void;
}

/**
 * Custom hook to handle mobile navigation interactions
 * Extracts common logic for search, menu, sort, and filter actions
 */
export const useMobileNavigation = (): MobileNavigationHandlers => {
    const handleSearchClick = useCallback(() => {
        const searchButton = document.querySelector('[aria-label*="search" i]');
        const searchInput = document.querySelector('input[placeholder="Search"]');

        if (window.innerWidth <= 320 && searchButton instanceof HTMLButtonElement) {
            searchButton.click();
        } else if (searchInput instanceof HTMLInputElement) {
            searchInput.focus();
            searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, []);

    const handleMenuClick = useCallback(() => {
        const menuButton = document.querySelector('[aria-label="Toggle menu"]');
        if (menuButton instanceof HTMLButtonElement) {
            menuButton.click();
        }
    }, []);

    const handleSortClick = useCallback(() => {
        const sortButton = document.querySelector('button:contains("SORT BY")') ||
            Array.from(document.querySelectorAll('button')).find(btn =>
                btn.textContent?.includes('SORT BY')
            );
        if (sortButton instanceof HTMLButtonElement) {
            sortButton.click();
        }
    }, []);

    const handleFilterClick = useCallback(() => {
        const filterButton = document.querySelector('button:contains("FILTER BY")') ||
            Array.from(document.querySelectorAll('button')).find(btn =>
                btn.textContent?.includes('FILTER BY')
            );
        if (filterButton instanceof HTMLButtonElement) {
            filterButton.click();
        }
    }, []);

    return {
        handleSearchClick,
        handleMenuClick,
        handleSortClick,
        handleFilterClick,
    };
}; 